import { SetupPage, TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { EndSellerNetwork } from '../../../end-seller-network.setup';

const parent: SetupPage = EndSellerNetwork.pages.endSellerManagement;
const path = 'invitation-codes';
const title = 'PAGE.END_SELLER_NETWORK.MANAGEMENT.INVITATION_CODES.TITLE';

const res = ['exportCsv', 'print', 'create'];

export const EndSellerManagementInvitationCodesTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
